export default {"src":"/_next/static/media/Female-07.ce38f224.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};